import { Directive, OnInit, OnDestroy } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs';
import { RemoteSearchService } from '@core/services/remote-search.service ';
import { SearchGridComponent } from '../components/grid/search-grid.component';
import { UiColumn } from '../ui/ui-column';

@Directive({
  selector: "[gridDataBinding]",
  standalone: true
})
export class GridDataBindingDirective extends DataBindingDirective implements OnInit, OnDestroy {

  private subscription: Subscription;

  prevUrl: string;
  url: string;

  constructor(private remote: RemoteSearchService, grid: GridComponent) {
    super(grid);
  }

  public override ngOnInit(): void {
    this.subscription = this.remote.subscribe((result) => {

      if (this.remote.loadData) {
        this.grid.loading = false;
        this.grid.data = result;
        this.notifyDataChange();
      }
      
    });

    super.ngOnInit();

    this.grid.loading = false;
  }

  public override ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    super.ngOnDestroy();
  }

  public bind(postData: any, apiController: string, searchGrid?: SearchGridComponent, columns?: UiColumn[], st?: State): void {
    this.grid.loading = true;
    if (st) {
      this.state = st;
    }

    if (postData != null) {
      this.remote.query(this.state, postData, apiController, searchGrid, this.grid, columns);
    }
  }
}
